export type MitekDocType = 'SELFIE' | 'DL_FRONT' | 'PASSPORT' | 'DOCUMENT';
